/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Overwrite_All_TitleInputs */



/**
* | output |
* | --- |
* | "Overwrite All" |
*
* @param {Iconik_Publish_Overwrite_All_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_overwrite_all_title = /** @type {((inputs?: Iconik_Publish_Overwrite_All_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Overwrite_All_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout ecraser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle überschreiben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sovrascrivi tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перезаписать все")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sobrescribir todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部覆盖")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて上書き")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी को ओवरराइट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sobrescrever tudo")
	return /** @type {LocalizedString} */ ("Overwrite All")
});